<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Cartillas adicionales</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
            <div class="select2-field">
              <v-select label="descripcion" @input="inputRuta" @search="onSearchRutas" id="ruta" :options="rutas" placeholder="Escriba una ruta..." v-model="selectedRuta"></v-select>
              <label for="ruta">Ruta</label>
            </div>
          </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-group">
          <div class="form-field">
            <input-field @keyup.enter="cargarCartillas" id="numero_cartilla" v-model="numero_cartilla" placeholder="Escriba un número...">
              Número de cartilla
            </input-field>
          </div>
          <button @click="cargarCartillas" type="button" class="btn-info">
            <i class="fa fa-search"></i>
          </button>
        </div>
        
      </div>
    </div>
    <div style="max-height: 300px" class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Ruta</th>
            <th>Fecha de venta</th>
            <th>Día de recaudación</th>
            <th>Número de documento</th>
            <th>Recaudador</th>
            <th>Cliente</th>
            <th>Observación</th>
            <th>Número de pagos</th>
            <th>Valor de pago</th>
            <th>Total</th>
            <th>Saldo</th>
            <th>
              <!-- <div>
                <label for="seleccionar_todos">
                    <input type="checkbox" name="seleccionar_todos" id="seleccionar_todos" v-model="seleccionar_todos"><span></span>
                </label>
              </div> -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cartilla, index) in cartillas" :key="index">
            <td>
              {{ cartilla.ruta.descripcion }}
            </td>
            <td>
              {{ cartilla.fecha }}
            </td>
            <td>
              {{ cartilla.descripcion_dia_cobro }}
            </td>
            <td>
              {{ cartilla.numero_documento }}
            </td>
            <td>
              {{ cartilla.recaudador.nombre }}
            </td>
            <td>
              {{ cartilla.nombre_cliente }}
            </td>
            <td>
              {{ cartilla.observacion }}
            </td>
            <td>
              {{ cartilla.numero_pagos }}
            </td>
            <td>
              {{ moneyFormat(cartilla.valor_pagos) }}
            </td>
            <td>
              {{ moneyFormat(cartilla.venta_total) }}
            </td>
            <td>
              {{ moneyFormat(cartilla.saldo) }}
            </td>
            <td>
                <div>
                    <label :for="'seleccionar' + index">
                        <input v-model="cartillasSeleccionadas" :value="cartilla.id" type="checkbox" :id="'seleccionar' + index"><span></span>
                    </label>
                </div>
            </td>
          </tr>
          <tr v-show="cartillas.length === 0">
            <td colspan="11">No se ha encontrado recaudaciones</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-buttons">
        <button @click="asignar" class="btn-success" type="button"><i class="fa fa-check"></i><span>Asignar seleccionadas</span></button>
        <button @click="cerrar" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        recaudacionId: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            cartillasSeleccionadas: [],
            cartillas: [],
            seleccionar_todos: false,
            moneyFormat: moneyFormat,
            selectedRuta: null,
            rutas: [],
            numero_cartilla: ''
        };
    },
    methods: {
      onSearchRutas: function (search, loading) {
        loading(true);
        let that = this;
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
          if (
            (this.readyState == 4 && this.status == 200) ||
            this.status == 201
          ) {
            let json = JSON.parse(this.responseText);
            that.rutas = json;
            loading(false);
          } else loading(false);
        };
        xmlhttp.open(
          "GET",
          url + "/search/rutas?search=" + search,
          true
        );
        xmlhttp.send();
      },
      inputRuta: function () {
        if (this.selectedRuta != null)
         this.cargarCartillas();
      },
        asignar: function () {
            swal({
                title: "¿Deseas asignar las cartillas seleccionadas?",
                text: "Se requiere confirmación",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sí",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    axios.post(url + '/logistica/asignar-cartillas/' + this.recaudacionId, {
                        cartillas: this.cartillasSeleccionadas
                    }).then(() => {
                      this.$emit('asignadas');
                      swal('Las cartillas adicionales han sido asignadas.', 'Realizado', 'success');
                      this.cerrar();
                    }).catch(() => {
                        swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                    });
                }
            });
        },
        cerrar: function () {
            this.$emit('cerrar');
        },
        cargarCartillas: function () {
          if (this.selectedRuta != null) {
            axios.get(url + '/logistica/cartillas-adicionales', {
                params: {
                    recaudacionId: this.recaudacionId,
                    ruta_id: this.selectedRuta != null?this.selectedRuta.id: '',
                    numero_cartilla: this.numero_cartilla
                }
            }).then(({data}) => {
                this.cartillas = data;
            });
          }
          else 
            swal('Debe seleccionar una ruta.', 'Aviso', 'warning');
        }
    },
    mounted: function () {
        //this.cargarCartillas();
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/CartillasAdicionales.vue